import { render, staticRenderFns } from "./ViewActivity.vue?vue&type=template&id=654e8c32&scoped=true"
import script from "./ViewActivity.vue?vue&type=script&lang=js"
export * from "./ViewActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654e8c32",
  null
  
)

export default component.exports